import React from 'react';

import { Card, Icon, Grid, Table, Label } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import numeral from 'numeral';

import { sciFormatted } from '../../../utils/formatting';
import DyzioInstagramEmbed from './dyzio-instagram-embed';

const smallMargin = { marginTop: 3 };
const truncate = str => (str.length > 40 ? `${str.substring(0, 37)}...` : str);
const NUM_COLUMNS = 3;
const INSTAGRAM_POST_URL = 'https://www.instagram.com/p';

const PostsSummary = props => {
  const { profile } = props;

  const posts = _.get(profile, 'rawInstagramPosts', []);
  const followerCount = _.get(profile, 'instagramCount', 1);
  console.log(profile);

  const orderedByLikes = _.orderBy(posts, 'likeCount', 'desc');

  const top3Organic = _.take(orderedByLikes, 3);

  const top3Ads = _.take(_.filter(orderedByLikes, 'isAd'), 3);


  return (
    <Card fluid>
      <Card.Content>

        <h2>top organic content</h2>
        <Grid>
          <Grid.Row columns={NUM_COLUMNS}>
            { _.map(top3Organic, (post => {
              const { isAd, likeCount, viewCount, commentCount, engagementCount } = post;
              const engagementRate = (engagementCount / followerCount) * 100;

              return (<Grid.Column key={post.shortcode}>
                <a
                  title="open on Instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`${INSTAGRAM_POST_URL}/${post.shortcode}`}
                >
                  <DyzioInstagramEmbed
                    assetId={post.shortcode}
                    useInstagramStyle
                  />
                </a>
                <Table singleLine style={smallMargin}>
                  <Table.Row>
                    <Table.Cell>
                      <Icon name="like outline" /> { sciFormatted(likeCount) }
                    </Table.Cell>
                    <Table.Cell>
                      <Icon name="comments outline" /> { sciFormatted(commentCount) }
                    </Table.Cell>
                    <Table.Cell>
                      <Icon name="eye" /> { sciFormatted(viewCount) }
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell colSpan="3" style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {truncate(post.text)}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell colSpan="2">
                      <Icon name="percent" color="pink" /> { numeral(engagementRate).format('0.00') } ENG. RATE
                    </Table.Cell>
                    <Table.Cell style={{ textAlign: 'center' }}>
                      <strong>{ isAd ? <Label color="pink">#AD</Label> : <Label>ORGANIC</Label>}</strong>
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell colSpan="3">
                      <Icon name="at" color="pink" />
                      { _.map(post.mentions, m => (<Label>{_.toLower(m)}</Label>)) }
                    </Table.Cell>
                  </Table.Row>
                </Table>
              </Grid.Column>);
            }))
            }
          </Grid.Row>
        </Grid>


        { !_.isEmpty(top3Ads) && <h2>top branded content (#AD)</h2> }
        <Grid>
          <Grid.Row columns={NUM_COLUMNS}>
            { _.map(top3Ads, (post => {
              const { isAd, likeCount, viewCount, commentCount, engagementCount } = post;
              const engagementRate = (engagementCount / followerCount) * 100;

              return (<Grid.Column key={post.shortcode}>
                <a
                  title="open on Instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`${INSTAGRAM_POST_URL}/${post.shortcode}`}
                >
                  <DyzioInstagramEmbed
                    assetId={post.shortcode}
                    useInstagramStyle
                  />
                </a>
                <Table singleLine style={smallMargin}>
                  <Table.Row>
                    <Table.Cell>
                      <Icon name="like outline" /> { sciFormatted(likeCount) }
                    </Table.Cell>
                    <Table.Cell>
                      <Icon name="comments outline" /> { sciFormatted(commentCount) }
                    </Table.Cell>
                    <Table.Cell>
                      <Icon name="eye" /> { sciFormatted(viewCount) }
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell colSpan="3" style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {truncate(post.text)}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell colSpan="2">
                      <Icon name="percent" color="pink" /> { numeral(engagementRate).format('0.00') } ENG. RATE
                    </Table.Cell>
                    <Table.Cell style={{ textAlign: 'center' }}>
                      <strong>{ isAd ? <Label color="pink">#AD</Label> : <Label>ORGANIC</Label>}</strong>
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell colSpan="3">
                      <Icon name="at" color="pink" />
                      { _.map(post.mentions, m => (<Label>{_.toLower(m)}</Label>)) }
                    </Table.Cell>
                  </Table.Row>
                </Table>
              </Grid.Column>);
            }))
            }
          </Grid.Row>
        </Grid>

      </Card.Content>
    </Card>
  );
};

PostsSummary.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default PostsSummary;



// WEBPACK FOOTER //
// ./src/containers/summary/components/posts-summary.js